import "../../index29.css";
import { jsx as i } from "react/jsx-runtime";
import { _ as u } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import m from "../RawButton/index.js";
const b = "_button_1vbet_1", d = "_round_1vbet_31", p = "_primary_1vbet_34", y = "_secondary_1vbet_51", l = "_tertiary_1vbet_69", t = {
  button: b,
  round: d,
  primary: p,
  secondary: y,
  tertiary: l
};
function B(r) {
  const {
    ariaLabel: o,
    children: n,
    className: a,
    variant: s,
    round: e = !0,
    ...c
  } = r, _ = u(
    t.button,
    t[s],
    e && t.round,
    a
  );
  return /* @__PURE__ */ i(
    m,
    {
      className: _,
      "aria-label": o,
      ...c,
      children: n
    }
  );
}
export {
  B as default
};
